import ProductDescription from './ProductDescription'

const NutSeedButtersProduct = {
  ...ProductDescription,
  category: '00',
  subCategory: '003',
  IsBroadband: false,
  Iron: '',
  Protein: '',
  Texture: '',
  OtherTexture: null,
  Type: '',
  Size: '',
}

export default NutSeedButtersProduct
